<template>
  <div class="auto">
    <AutoFights :farmers="farmers" :requestFarmers="this.update"></AutoFights>    
  </div>
</template>

<script>

import store from "@/store";
import Vue from 'vue';
import AutoFights from "@/components/AutoFights.vue";

export default {
  components: {
    AutoFights
  },
  data() {
    return {
      user: store.getters.getUser,
      farmers: [],
      unsubFarmers: null,
    }
  },
  async mounted() {
    this.getFullFarmers({uid: this.user.uid}).then((res) => {
      this.farmers = res.data.farmers;
    })
  },
  methods: {
    update() {
      this.getFullFarmers({uid: this.user.uid}).then((res) => {
        this.farmers = res.data.farmers;
      });  
    },
    getFullFarmers: Vue.firebase.functions.getFullFarmers
  }
}

</script>

<style>
ul li {
  text-align: left;
}

</style>
